<template>
  <loan-status-alert-container
    :loan="loan"
    :borrower-action-required="!loan.has_no_applicable_pricing"
  >
    <template v-if="loan.has_no_applicable_pricing" #borrower>
      <p>
        {{ $t("components.loan.status.alerts.validated.borrower.no_charge") }}
      </p>
    </template>
    <template v-else-if="loan.contribution_only" #borrower>
      <i18n
        path="components.loan.status.alerts.validated.borrower.contribution_only.message"
        tag="p"
      >
        <template #contribution>
          <icon-button
            variant="ghost-secondary"
            size="inline"
            @click="$emit('jump', sections.contribution)"
            >{{
              $t("components.loan.status.alerts.validated.borrower.contribution_only.contribution")
            }}</icon-button
          >
        </template>
      </i18n>
    </template>
    <template v-else #borrower>
      <i18n path="components.loan.status.alerts.validated.borrower.payment.message" tag="p">
        <template #pay>
          <icon-button
            variant="ghost-secondary"
            size="inline"
            @click="$emit('jump', sections.contribution)"
            >{{ $t("components.loan.status.alerts.validated.borrower.payment.pay") }}</icon-button
          >
        </template>
      </i18n>
    </template>

    <template v-if="loan.has_no_applicable_pricing" #owner>
      <p>
        {{ $t("components.loan.status.alerts.validated.owner.no_charge") }}
      </p>
    </template>
    <template v-else-if="loan.contribution_only" #owner>
      <p>
        {{
          $t("components.loan.status.alerts.validated.owner.contribution_only", {
            name: loan.borrower_user.name,
          })
        }}
      </p>
    </template>
    <template v-else #owner>
      <p>
        {{
          $t("components.loan.status.alerts.validated.owner.payment", {
            name: loan.borrower_user.name,
          })
        }}
      </p>
    </template>

    <template v-if="loan.has_no_applicable_pricing" #admin>
      <p>{{ $t("components.loan.status.alerts.validated.admin.no_charge") }}</p>
    </template>
    <template v-else-if="loan.contribution_only" #admin>
      <p>
        {{
          $t("components.loan.status.alerts.validated.admin.contribution_only", {
            name: loan.borrower_user.name,
          })
        }}
      </p>
    </template>
    <template v-else #admin>
      <p>
        {{
          $t("components.loan.status.alerts.validated.admin.payment", {
            name: loan.borrower_user.name,
          })
        }}
      </p>
    </template>
  </loan-status-alert-container>
</template>

<script>
import LoanStatusAlertContainer from "@/components/Loan/Status/Alerts/LoanStatusAlertContainer.vue";
import IconButton from "@/components/shared/IconButton.vue";
import { sections } from "@/components/Loan/FullLoanSections";
export default {
  name: "LoanValidated",
  components: {
    IconButton,
    LoanStatusAlertContainer,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sections,
    };
  },
};
</script>

<style lang="scss"></style>
